import React from "react";
import { observer } from "mobx-react";

import { Team, Tournament } from "@gp/models";

import { StreakStat } from "@data-types/sport-stats/SportStatsTypes";

import { StreakStatItem } from ".";

export const StreakSection = observer(function StreakSection(props: {
	title: string;
	data: StreakStat[];
	tournament: Tournament | undefined;
	homeTeam: Team | undefined;
	awayTeam: Team | undefined;
}) {
	const { data, title, tournament, homeTeam, awayTeam } = props;

	if (!data) return null;

	return (
		<div className="statistics__card">
			<div className="statistics__header">
				<span className="statistics__title">{title}</span>
			</div>

			<div className="statistics__body">
				{data.map((item, index) => (
					<StreakStatItem
						key={index}
						item={item}
						tournament={tournament}
						homeTeam={homeTeam}
						awayTeam={awayTeam}
					/>
				))}
			</div>
		</div>
	);
});
